import React from "react";
import { buildTranslator, RadioButtonRowCustomFormField } from "../../../../amorg-common";
import { RadioButton } from "../../../../designSystem/inputs/RadioButton";
import styled from "styled-components";
import { tablet } from "../../../../designSystem/BreakPoints";
import { CustomFormFieldHeader } from "../../[parm]/_components/CustomFormFieldHeader";
import { Card } from "../../../../designSystem/Card";
import { AnswerFieldContext } from "../customFormFieldFactory";


type RadioButtonRowCustomFormFieldComponentProps = AnswerFieldContext & {
    field:RadioButtonRowCustomFormField
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function RadioButtonRowCustomFormFieldComponent(props:RadioButtonRowCustomFormFieldComponentProps):JSX.Element
{

    async function handleChange(value:string)
    {
        await props.onSubmit([{ fieldId: props.field.fieldId, value }]);
        props.doUpdate();
    }

    const answerField = props.answer.selections.find(s => s.fieldId === props.field.fieldId);
    const answerValue = answerField.value;

    const optionsCount = props.field.options.length;

    const translator = buildTranslator('da');

    return (
        <section>
            <CustomFormFieldHeader field={props.field} />

            {/* No card here - individual cards are created for each option */}
            <RadioGridContainer columns={optionsCount}>
                {props.field.options.map((option, index) => {
                    const checked = option.value === answerValue;
                    return (
                        <label htmlFor={props.field.fieldId + "_" + index } key={index}>
                        <Card variant="outlined" padding="0px">
                        <RadioGrid>
                            {option.imageUrl &&
                                <ImageSingle>
                                    <img src={`/images/ergocheck/${option.imageUrl}`} alt="Image image" />
                                </ImageSingle>
                            }

                            <RadioContainer>
                                <RadioButton
                                    disabled={props.disabled}
                                    name={props.field.fieldId + '_' + (props.inPrint ? '_print' : '')}
                                    id={props.field.fieldId + '_' + option.value + (props.inPrint ? '_print' : '')}
                                    onChange={handleChange}
                                    value={option.value}
                                    text={translator(option.content)}
                                    checked={checked}
                                />
                            </RadioContainer>

                        </RadioGrid>
                        
                        </Card>
                    </label>
                    )
                }
                )}
            </RadioGridContainer>
        
        </section>
    );
}

const ImageSingle = styled.div`
    grid-area:image;

    & img {
        width: 100%; 
        max-height: 100%;
        object-fit: cover;
    }
`

const RadioContainer = styled.div`
    display:grid;
    grid-area:radioButton;
    justify-self:center;
    align-self:center;


    & ul{
        padding:0 !important;
        margin:0;
    }

    & label {
        margin-left: 16px;
    }
`

const RadioGridContainer = styled.div<{columns:number}>`
    display:grid;
    grid-template-columns: repeat(${props => props.columns}, 1fr);
    gap:8px;

    @media only screen and (max-width: ${tablet}px) {
        grid-template-columns: 1fr;
    }
`

const RadioGrid = styled.div`
    
    padding:8px;
    display:grid;
    gap:16px;
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    grid-template-areas: 
        "image"
        "radioButton" 
        ;

    @media (max-width: ${tablet}px) {
        & ul{
            padding-left:16px;
        }
    }
`